import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic/Icon';
import type { ProjectGroupRelease } from '../../../../types';

import styles from '../../../issues/IssueComparison/IssueComparison.module.less';

type Props = {
  release?: ProjectGroupRelease;
  placeholder?: string;
  shouldShowChevron?: boolean;
  variant?: 'default' | 'light';
};

/**
 * Displays a release similar to RevisionDisplay
 */
const ReleaseDisplay: VoidFunctionComponent<Props> = ({
  release,
  placeholder,
  shouldShowChevron,
  variant = 'light',
}) => {
  const displayText = release?.title || placeholder || 'Select a release';

  return (
    <div
      className={cx(styles.releaseDisplay, {
        [styles.asButton]: shouldShowChevron,
        [styles.light]: variant === 'light',
      })}
    >
      {displayText}
      {shouldShowChevron && <Icon icon={icons.chevronDown} />}
    </div>
  );
};

export default ReleaseDisplay;
